<lib-mon-adhesion [configuration]="configuration"></lib-mon-adhesion>

